export default __webpack_public_path__ + "static/media/stack-icon.9861afd8.svg";